export const Capability_catalogue = 'CC';
export const Capability_adoption_reporting = 'CAR';
export const Sample_Central = 'SC';
export const Rac = 'RAC';
export const Atlas = 'ATL';
export const AtlasFR = 'ATL-FR';
export const AtlasDE = 'ATL-DE';
export const AUE = 'AUE';
export const PowerX = 'POWX';
export const PatientIq = 'PIQ';
export const AZSA = 'AZSA';
export const GTP = "GTP";
export const CODE = 'AZ 2D Code App';
export const HUB = 'Search Hub';
export const EP = 'MAP';
export const OCL = 'OCL';
export const IVS = 'IVS';
export const PBI = 'PBI';
export const PCD = 'PCD';
export const PIM = 'PIM';
export const PUEBLO = 'PUEBLO';
export const JPC = 'JPC';
export const JMH = 'JMH';
export const JMD = 'JMD';
export const JMA = 'JMA';
export const REGISTA = 'REGISTA';
export const AZCMS = 'AZCMS';
export const RR = 'MYACCESS';
export const MOR = 'MOR';
export const CAP = 'CAP';
export const WAINUA = 'WAINUA';
export const INTERRO = 'INTERRO';
export const PowerbiUrl="https://app.powerbi.com/groups/88f484d4-9332-4a7b-a27c-560cd3e81275/reports/75d170c9-57cb-4d4b-b771-9cb95d1c30fe/ReportSectionc51085170320701cc3e9?experience=power-bi"
export const DevPowerbiUrl="https://app.powerbi.com/groups/me/reports/5ac62d31-237d-487e-9a1f-46c936c2a492/7938e3e4e9f17e9eff7e?ctid=af8e89a3-d9ac-422f-ad06-cc4eb4214314&experience=power-bi"
export const CodeUrl = "https://barcode.astrazeneca.jp/home";
export const HubUrl = "https://d2a83o4gwi0ggx.cloudfront.net/searchHub";
export const EPUrl = "https://d2a83o4gwi0ggx.cloudfront.net/map";
export const NoAccessAPP = [Capability_catalogue, Capability_adoption_reporting, CODE, HUB, EP];
